// extracted by mini-css-extract-plugin
export default {"background":"styles_background__wt4hO","container":"styles_container__5CiLM","wrapper":"styles_wrapper__Ue5AX","title":"styles_title__l7-zc"};